<template>
  <b-modal
    id="edit-client"
    size="lg"
    :title="$t('generals.edit')"
    no-close-on-backdrop
    :ok-title="$t('generals.update')"
    :cancel-title="$t('generals.cancel')"
    cancel-variant="danger"
    ok-variant="success"
    @ok="onSubmit"
  >

    <validation-observer ref="infoClient">
      <b-row>
        <b-col md="12">
          <b-form-group
            :label="$t('clients.client')+'*'"
            label-for="name"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('clients.client')"
              rules="required"
            >
              <b-form-input
                id="name"
                v-model="client.title"
                size="lg"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col
          v-if="client.entity === 'fizichiskiy'"
          md="6"
        >
          <b-form-group
            :label="$t('clients.client_gender')"
          >
            <validation-provider
              #default="{ errors }"
              name="Gender"
            >
              <v-select
                v-model="client.gender"
                :options="genderOptions"
                :get-option-label="option => option.title[$i18n.locale]"
                :reduce="gender => gender.id"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col
          v-if="client.entity == 'yuridiskiy'"
          md="6"
        >
          <b-form-group :label="$t('clients.field_of_activity')">
            <validation-provider
              #default="{ errors }"
              name="spheres"
              rules="required"
            >
              <v-select
                v-model="client.sphere_of_activity"
                :options="getSpheresOfActivity"
                :reduce="sphere => sphere.id"
                label="title"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group :label="$t('clients.type_of_appeal')">
            <validation-provider
              #default="{ errors }"
              name="client_request"
            >
              <v-select
                v-model="client.client_request"
                label="title"
                multiple
                :options="GET_CLIENT_REQUESTS"
                :reduce="req => req.id"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group :label="$t('clients.payment_type')">
            <!-- <validation-provider
              #default="{ errors }"
              name="payment_type"
            > -->
              <v-select
                v-model="client.payment_type"
                :options="GET_CLIENT_PAYMENT_TYPES"
                label="title"
                :reduce="target => target.id"
              />
              <!-- <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider> -->
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group :label="$t('clients.client_wishes')">
            <validation-provider
              #default="{ errors }"
              name="client_interested"
            >
              <v-select
                v-model="client.client_interested"
                :options="GET_CLIENT_INTERESTED"
                label="title"
                multiple
                :reduce="interest => interest.id"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- <b-col
          v-if="client.entity == 'yuridiskiy'"
          md="6"
        >
          <b-form-group :label="$t('clients.company_employee')">
            <validation-provider
              #default="{ errors }"
              name="company_employee"
            >
              <b-form-input v-model="client.company_employee" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col> -->

        <!-- <b-col
          v-if="client.entity == 'yuridiskiy'"
          md="6"
        >
          <b-form-group :label="$t('clients.phone_number')">
            <validation-provider
              #default="{ errors }"
              name="employee_number"
            >
              <cleave
                id="employee_number"
                v-model="client.phones[0]"
                class="form-control"
                :raw="true"
                :options="optionsPhone"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col> -->

        <b-col md="6">
          <b-form-group :label="$t('clients.how_did_you_know_about_us')">
            <validation-provider
              #default="{ errors }"
              name="status"
            >
              <v-select
                v-model="client.target"
                :options="getTargets"
                label="title"
                :reduce="(target) => target.id"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <!-- <b-col md="6">
          <b-form-group :label="client.entity === 'yuridiskiy' ? $t('clients.day_of_foundation_of_the_company') : $t('clients.clients_birthday')">
            <flat-pickr
              v-model="client.birth_date"
              class="form-control bg-white"
              style="max-width: 250px;"
              :config="configdateTimePicker"
            />
          </b-form-group>
        </b-col> -->

        <b-col md="12">
          <b-form-group
            :label="$t('clients.description')"
            label-for="email"
          >
            <b-form-textarea
              id="textarea-default"
              v-model="client.description"
              rows="2"
            />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <b-form-group
            :label="$t('clients.email')"
            label-for="email"
          >
            <b-form-tags
              v-model="client.emails"
              :placeholder="$t('generals.add')"
              input-id="tags-basic"
              class="mb-2"
              :add-button-text="$t('clients.new')"
            />

          </b-form-group>
        </b-col>
        <!-- <b-col md="4">

          <b-form-group
            label="Статус"
            label-for="status"
          >
            <validation-provider
              #default="{ errors }"
              name="username"
              rules="required"
            >
              <b-form-group>
                <v-select
                  v-model="client.status_of_client"
                  label="title"
                  :reduce="status => status.id"
                  :options="statusClient"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col> -->

        <b-col md="12">
          <label for="">{{ $t('clients.telephone') }}</label>
          <b-form-tags
            v-model="client.phones"
            :placeholder="$t('generals.add')"
            input-id="tags-basic"
            class="mb-2"
            :add-button-text="$t('clients.new')"
          />
        </b-col>

      </b-row>
    </validation-observer>
  </b-modal>

</template>

<script>
import {
  BModal, BRow, BCol, BFormInput, BFormGroup, BFormTags, BFormTextarea,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { required } from '@validations'
import { mapActions, mapGetters } from 'vuex'
// import Cleave from 'vue-cleave-component'
// import flatPickr from 'vue-flatpickr-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Russian } from 'flatpickr/dist/l10n/ru'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  components: {
    BModal,
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BFormTags,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    // flatPickr,
    vSelect,
    // Cleave,
  },
  props: {
    clientInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      required,
      emails: [],
      phones: [],
      configdateTimePicker: {
        altInput: true,
        allowInput: true,
        altFormat: 'd.m.Y',
        dateFormat: 'Y-m-d',
        locale: Russian,
      },
      optionsPhone: {
        // prefix: '+998',
        blocks: [4, 2, 3, 2, 2],
        delimiter: '-',
      },
      genderOptions: [
        {
          title: {
            uz: 'Erkak',
            ru: 'Мужской',
            en: 'Male',
          },
          id: 'man',
        },
        {
          title: {
            uz: 'Ayol',
            ru: 'Женский',
            en: 'Female',
          },
          id: 'woman',
        },
      ],
      client: {
        title: '',
        description: '',
        status_of_client: null,
        phones: [],
        emails: {},
      },
    }
  },
  watch: {
    clientInfo() {
      this.client = this.clientInfo
    },
  },
  computed: {
    ...mapGetters('clients', ['getStatusClient', 'getOneClient', 'getSpheresOfActivity', 'getTargets', 'GET_CLIENT_PAYMENT_TYPES',
      'GET_CLIENT_INTERESTED', 'GET_CLIENT_REQUESTS']),
    statusClient() {
      return this.getStatusClient.map(status => ({
        id: status.id,
        title: status.title.ru,
      }))
    },
  },

  // watch: {
  //   getOneClient(newValue) {
  //     const {
  //       title, description, phones, emails, status_of_client,
  //     } = newValue
  //     this.client.title = title
  //     this.client.description = description
  //     this.client.status_of_client = status_of_client.id
  //     this.phones = Object.keys(phones).map(key => phones[key])
  //     this.emails = Object.keys(emails).map(key => emails[key])
  //   },
  // },

  async mounted() {
    if (!this.getStatusClient.length) {
      await this.GET_STATUS_CLIENT()
    }
    this.FETCH_ACTIVITY_SPHERES()
    this.FETCH_CLIENT_INTERESTED()
    this.FETCH_CLIENT_PAYMENT_TYPES()
    this.FETCH_CLIENT_REQUESTS()
    this.FETCH_TARGETS()
  },

  methods: {
    ...mapActions('clients', ['GET_STATUS_CLIENT', 'UDATE_ONE_CLIENT', 'FETCH_CLIENT_PAYMENT_TYPES', 'FETCH_ACTIVITY_SPHERES',
      'FETCH_TARGETS', 'FETCH_CLIENT_INTERESTED', 'FETCH_CLIENT_REQUESTS']),
    onSubmit(bvModalEvt) {
      bvModalEvt.preventDefault()
      // this.client.phones = {}
      // this.client.emails = {}
      // this.phones.forEach((phone, index) => {
      //   this.client.phones[index] = phone
      // })
      // this.emails.forEach((email, index) => {
      //   this.client.emails[index] = email
      // })

      this.$refs.infoClient.validate().then(async success => {
        if (success) {
          // console.log(this.client)

          await this.UDATE_ONE_CLIENT(this.client)

          this.$nextTick(() => {
            this.$bvModal.hide('edit-client')
          })

          this.$emit('refresh')
        }
      })
    },
  },

}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";

</style>
